module.exports = __webpack_public_path__ + "static/any_device-4f9d3168980cc4cf39be907cbe31dd1e.svg";